export default "__VITE_ASSET__BOZ9PYmL__"